import React, { useContext } from "react";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography
} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";

// Passo a passo para conectar um assistente de IA (Claude, Codex, ChatGPT,
// Cursor...) ao conector MCP do Floow Chat. O conector e o mesmo para todos:
// muda so onde cada assistente pede o endereco. O login e com a conta do
// Floow Chat — nao precisa de token para o Claude nem para o Codex.
//
// O endereco ja vem com o nome da empresa (/mcp/c/<apelido>): o Claude nao
// aceita dois conectores com o mesmo endereco, e quem implanta varias contas
// precisa de um conector por cliente. O apelido nao escolhe a conta — quem
// decide e o login feito no conector.
const BASE = "https://mcp.floow.chat/mcp";

const apelidoDaEmpresa = user => {
  const nome = String(user?.company?.name || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40).replace(/-+$/, "");
  return nome || `empresa-${user?.companyId || "floow"}`;
};

const COR = "#2563EB";

const Copiavel = ({ valor, rotulo }) => {
  const copiar = () => {
    navigator.clipboard.writeText(valor);
    toast.success(rotulo ? `${rotulo} copiado.` : "Copiado.");
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      style={{
        background: "#F1F5F9", border: "1px solid #CBD5E1", borderRadius: 10,
        padding: "6px 6px 6px 12px", margin: "6px 0 10px", gap: 8
      }}
    >
      <code style={{ flex: 1, fontSize: 13, color: "#0F172A", wordBreak: "break-all" }}>{valor}</code>
      <Tooltip title="Copiar">
        <IconButton size="small" onClick={copiar}>
          <FileCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const Secao = ({ titulo, children }) => (
  <Box style={{ marginTop: 20 }}>
    <Typography style={{ fontWeight: 700, color: "#0F172A", marginBottom: 6 }}>{titulo}</Typography>
    <Box style={{ color: "#334155", fontSize: 14, lineHeight: 1.6 }}>{children}</Box>
  </Box>
);

const ConectorAssistentes = ({ open, onClose }) => {
  const { user } = useContext(AuthContext);
  const apelido = apelidoDaEmpresa(user);
  const ENDERECO = `${BASE}/c/${apelido}`;
  const NOME = `${user?.company?.name || "Floow Chat"} · Floow Chat`;
  return (
  <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Conectar um assistente de IA</DialogTitle>
    <DialogContent>
      <Typography variant="body2" style={{ color: "#64748B" }}>
        Com o conector, o Claude, o Codex ou outro assistente de IA monta e ajusta os seus fluxos, agentes de IA e base de
        conhecimento, cria usuários, departamentos e Kanban, e traz relatórios — conversando. Ele só enxerga a empresa do login,
        cria fluxos desligados e pede a sua confirmação antes de qualquer coisa que chegue aos seus clientes ou que apague algo.
      </Typography>

      <Secao titulo="Endereço do conector">
        <Copiavel valor={ENDERECO} rotulo="Endereço" />
        <Typography variant="body2" style={{ color: "#64748B" }}>
          O final do endereço já vem com o nome desta empresa. Cada conta tem o seu: copie o endereço dentro da conta de cada
          cliente. Quem define a conta é o login que você faz no conector.
        </Typography>
      </Secao>

      <Secao titulo="Claude (site, aplicativo ou Claude Desktop)">
        1. No Claude, abra <b>Personalizar → Conectores</b> e clique em <b>+ → Adicionar conector personalizado</b>.<br />
        2. Nome: <b>{NOME}</b>. URL: o endereço acima. Deixe os campos de OAuth em branco.<br />
        3. Clique em <b>Conectar</b> e entre com o <b>e-mail e a senha desta conta do Floow Chat</b>.
      </Secao>

      <Secao titulo="Codex (terminal ou extensão do editor)">
        Rode os dois comandos abaixo. O segundo abre o navegador para você entrar com a sua conta do Floow Chat.
        <Copiavel valor={`codex mcp add floow-${apelido} --url ${ENDERECO}`} rotulo="Comando" />
        <Copiavel valor={`codex mcp login floow-${apelido}`} rotulo="Comando" />
      </Secao>

      <Secao titulo="Outros assistentes (ChatGPT, Cursor e outros compatíveis com MCP)">
        Use o mesmo endereço. Se o assistente abrir uma tela de login, entre com a sua conta do Floow Chat. Se ele pedir uma
        chave em vez de login, gere um token em <b>Documentação API</b> e informe no cabeçalho
        <code style={{ margin: "0 4px" }}>Authorization</code>com o valor <code>Bearer SEU_TOKEN</code>.
      </Secao>

      <Secao titulo="Para começar, experimente pedir">
        • "Quais eventos de venda estão chegando sem fluxo na minha conta?"<br />
        • "Cria um fluxo de boas-vindas com menu: comprar, tirar dúvida e falar com atendente."<br />
        • "Me mostra o prompt do meu agente de IA e sugere melhorias."
      </Secao>
    </DialogContent>
    <DialogActions style={{ padding: "8px 24px 20px" }}>
      <Button onClick={onClose} variant="contained" style={{ background: COR, color: "#fff" }}>
        Entendi
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default ConectorAssistentes;
